export default __webpack_public_path__ + "static/rossana-cbe5f4b14f078af7420ac743c0c52aac.png";